import React, { useState } from "react";
import { answerRecallQuestion, getExplainAnswer } from "api/Capsule.api";
import "./style.scss";

const RecallQuestionModal = ({ capsuleId, questions, onClose, onSuccess }) => {
  const [answers, setAnswers] = useState({});
  const [error, setError] = useState(null);
  const [showExplanations, setShowExplanations] = useState(false);
  const [explanations, setExplanations] = useState({}); // { questionId: { explanation, correctAnswer } }

  const handleAnswerChange = (questionId, value) => {
    setAnswers((prev) => ({ ...prev, [questionId]: value }));
  };

  const handleSubmit = async () => {
    try {
      for (const question of questions) {
        const { id: questionId } = question;
        const answer = answers[questionId];
        if (!answer) {
          setError("Please answer all questions.");
          return;
        }
        console.log(`Submitting answer for question ${questionId}: ${answer}`);
        await answerRecallQuestion(questionId, answer, capsuleId);
      }
      setError(null);

      // Fetch explanations for all questions
      const explanationData = {};
      for (const question of questions) {
        const explain = await getExplainAnswer(question.id, capsuleId);
        explanationData[question.id] = {
          explanation: explain.data.explaination,
          correctAnswer: explain.data.correctAnswer,
        };
      }
      setExplanations(explanationData);
      setShowExplanations(true);

      // Wait 5 seconds before closing modal and notifying success
      await new Promise((resolve) => setTimeout(resolve, 5000));

      onSuccess();
      onClose();
    } catch (err) {
      console.error("Error submitting answers:", err);
      setError("Failed to submit answers. Please try again.");
    }
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>Answer Recall Questions</h2>
        {questions?.length === 0 ? (
          <p>No recall questions available.</p>
        ) : (
          questions?.map((question) => (
            <div key={question.id} className="question-item">
              <p>{question.question}</p>
              <ul>
                {["A", "B", "C", "D"].map((option) => {
                  const choiceText = question[`choices${option}`];
                  const isCorrect =
                    showExplanations &&
                    explanations[question.id]?.correctAnswer === option;
                  return (
                    <li key={option}>
                      <label className={isCorrect ? "correct-answer" : ""}>
                        <input
                          type="radio"
                          name={question.id}
                          value={option}
                          onChange={(e) =>
                            handleAnswerChange(question.id, e.target.value)
                          }
                          disabled={showExplanations}
                          checked={answers[question.id] === option}
                        />
                        {choiceText}
                      </label>
                    </li>
                  );
                })}
              </ul>
              {showExplanations && explanations[question.id]?.explanation && (
                <p className="explanation">
                  Explanation: {explanations[question.id].explanation}
                </p>
              )}
            </div>
          ))
        )}
        {error && <p className="error">{error}</p>}
        <div className="modal-actions">
          <button onClick={onClose} disabled={showExplanations}>
            Cancel
          </button>
          <button onClick={handleSubmit} disabled={showExplanations}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecallQuestionModal;
